import correct from '@/assets/img/documents/house-hold/podsumowanie-zgloszenia.jpg';
import wrong from '@/assets/img/documents/house-hold/podsumowanie-zgloszenia-wrong.jpg';

import Card from '@/components/Card';
import { Uploader } from '@/components/ui/Uploader/Uploader';
import { ATTACHMENT_TYPES } from '@/consts';

import { useLingui } from '@lingui/react';

export const DAMAGE_REPORT_NAME = 'damage_report';

const DamageReport = () => {
  const { i18n } = useLingui();

  const instructionProps = {
    title: i18n.t('Jak poprawnie dodać zgłoszenie szkody?'),
    steps: [
      i18n.t('Upewnij się, że wszystkie dane nieruchomości są widoczne.'),
      i18n.t('Sprawdź, czy załączasz wszystkie strony.'),
      i18n.t('Jeśli przesyłasz zdjęcia – sprawdź, czy dokument jest czytelny.'),
      i18n.t('Jeśli plik jest zabezpieczony – dołącz hasło.'),
    ],
    correctImg: correct,
    wrongImg: wrong,
  };

  return (
    <Card>
      <Uploader
        title={i18n.t('Zgłoszenie szkody')}
        instructionProps={instructionProps}
        inputFieldName={DAMAGE_REPORT_NAME}
        attachmentTypeId={ATTACHMENT_TYPES.ZGLOSZENIE_SZKODY}
        data-testid={`${DAMAGE_REPORT_NAME}-uploader`}
      />
    </Card>
  );
};

export default DamageReport;
